/* eslint-disable */
import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Grid, Typography } from '@mui/material';
import SubCard from 'ui-component/cards/SubCard';

function renderErrorMessages(errors) {
    return Object.keys(errors).map((key) => {
        if (typeof errors[key] === 'object' && !Array.isArray(errors[key])) {
            // For nested objects, call renderErrorMessages recursively
            return (
                <div key={key}>
                    <Typography variant="subtitle1" color="error" sx={{ textTransform: 'capitalize' }}>
                        {key}:
                    </Typography>
                    <div style={{ paddingLeft: '16px' }}>{renderErrorMessages(errors[key])}</div>
                </div>
            );
        } else if (Array.isArray(errors[key])) {
            // For arrays, iterate through the array
            return errors[key].map((item, index) => (
                <div key={`${key}-${index}`}>
                    <Typography variant="subtitle1" color="error" sx={{ textTransform: 'capitalize' }}>
                        {key} {index + 1}:
                    </Typography>
                    <div style={{ paddingLeft: '16px' }}>{renderErrorMessages(item)}</div>
                </div>
            ));
        } else {
            // For strings, render the error message directly
            return (
                <Typography key={key} color="error" sx={{ textTransform: 'capitalize' }}>
                    {key}: {errors[key]}
                </Typography>
            );
        }
    });
}

export default function FormError({ errors }) {
    return (
        <>
            {errors && Object.keys(errors).length > 0 && (
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <SubCard title="Missing Required Field*">{renderErrorMessages(errors)}</SubCard>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    );
}
